import React, { useContext, useState } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  Typography,
  IconButton,
} from "@material-ui/core";
import { Clear, Save } from "@material-ui/icons";
import { MainContext } from "../context/main";
import { useHistory, useLocation } from "react-router-dom";
import { LangContext } from "../context/lang";

const useStyle = makeStyles((theme: Theme) => ({
  content: {
    width: theme.spacing(55),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  icon: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    color: theme.palette.primary.main,
  },
  btn: { textTransform: "unset", fontWeight: "bold" },
  cancelBtn: {
    position: "absolute",
    top: theme.spacing(0.5),
    right: theme.spacing(0.5),
    color: theme.palette.error.main,
  },
}));

const ConfirmSaveDesign = (props: { saveProject: Function }) => {
  const classes = useStyle();
  const history = useHistory();
  const location = useLocation();
  const jsonState = JSON.parse(String(location.state));
  const [loading, setloading] = useState<Boolean>(false);
  const { lang } = useContext(LangContext);
  const { saveDesign, setsaveDesign } = useContext(MainContext);

  const _onCancel = () => {
    history.push(String(saveDesign));
    setsaveDesign(undefined);
  };

  const _onSave = async () => {
    setloading(true);
    await props.saveProject();
    history.push(String(saveDesign));
    setsaveDesign(undefined);
  };

  return (
    <Dialog
      open={Boolean(saveDesign)}
      onClose={() => {}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <IconButton
        size="small"
        className={classes.cancelBtn}
        onClick={() => {
          setsaveDesign(undefined);
        }}
      >
        <Clear />
      </IconButton>
      <DialogContent className={classes.content}>
        <Save className={classes.icon} />
        <Typography variant="h6">{`${lang.data.confirmSavePrimary} "${jsonState.work_order_no}" ?`}</Typography>
        <DialogContentText>{`${lang.data.confirmSaveSecondary}`}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          className={classes.btn}
          variant="contained"
          onClick={_onCancel}
          color="secondary"
          disabled={Boolean(loading)}
        >
          {lang.data.donotsave}
        </Button>
        <Button
          className={classes.btn}
          variant="contained"
          onClick={_onSave}
          color="primary"
          autoFocus
          disabled={Boolean(loading)}
        >
          {lang.data.save}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmSaveDesign;
